import { render, staticRenderFns } from "./OleMiss_IdentifyingUnknownAcidW2_Results.vue?vue&type=template&id=2f449e30&"
import script from "./OleMiss_IdentifyingUnknownAcidW2_Results.vue?vue&type=script&lang=js&"
export * from "./OleMiss_IdentifyingUnknownAcidW2_Results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VForm,VSimpleTable,VTextarea})
